import React from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Card,
  Box,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import {
  Sparkles,
  ArrowRight,
  HelpCircle,
} from "lucide-react";
import { colors, borderRadiusPx, customShadows } from "../../../../../theme";
import { CommonButton } from "../../../../Components/ui";
import { Path } from "../../../../../static/Constants";

const AboutCtaCard = () => {
  const history = useHistory();

  return (
    <Card
      sx={{
        p: { xs: 3.5, sm: 4.5 },
        borderRadius: borderRadiusPx.xl,
        background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.primary.dark} 100%)`,
        color: colors.neutral.white,
        boxShadow: customShadows.cardHover,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative Background Circles */}
      <Box
        sx={{
          position: "absolute",
          top: -40,
          right: -40,
          width: 200,
          height: 200,
          borderRadius: borderRadiusPx.full,
          background: "radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -60,
          left: -20,
          width: 240,
          height: 240,
          borderRadius: borderRadiusPx.full,
          background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)",
          pointerEvents: "none",
        }}
      />

      <Grid container spacing={3} alignItems="center" justifyContent="space-between">
        <Grid item xs={12} md={8}>
          <Stack spacing={1.5}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                px: 1.5,
                py: 0.5,
                borderRadius: borderRadiusPx.full,
                bgcolor: "rgba(255, 255, 255, 0.18)",
                width: "fit-content",
              }}
            >
              <Sparkles size={15} color={colors.neutral.white} />
              <Typography variant="caption" sx={{ fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.05em", color: colors.neutral.white }}>
                Join the Revolution
              </Typography>
            </Box>

            <Typography
              variant="h4"
              sx={{
                fontWeight: 900,
                letterSpacing: "-0.5px",
                fontSize: { xs: "1.5rem", sm: "1.85rem", md: "2.1rem" },
                color: colors.neutral.white,
              }}
            >
              Ready to Experience Provably Fair Gaming?
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "rgba(255, 255, 255, 0.85)",
                fontSize: { xs: "0.9rem", sm: "1rem" },
                lineHeight: 1.6,
                maxWidth: 620,
              }}
            >
              Connect your Web3 wallet in seconds, choose your preferred lottery format, and play with confidence knowing every draw is verified on-chain.
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} md={4}>
          <Stack spacing={1.5} direction={{ xs: "column", sm: "row", md: "column" }} justifyContent={{ md: "flex-end" }}>
            <CommonButton
              variant="contained"
              size="large"
              component={Link}
              to={Path.allLotteries}
              onClick={() => history.push(Path.allLotteries)}
              endIcon={<ArrowRight size={18} />}
              sx={{
                bgcolor: colors.neutral.white,
                color: colors.primary.main,
                fontWeight: 800,
                boxShadow: "0 4px 14px rgba(0, 0, 0, 0.15)",
                "&:hover": {
                  bgcolor: colors.slate[100],
                  color: colors.primary.dark,
                },
              }}
            >
              Browse Active Lotteries
            </CommonButton>

            <CommonButton
              variant="outline"
              size="large"
              component={Link}
              to={Path.help}
              onClick={() => history.push(Path.help)}
              startIcon={<HelpCircle size={18} />}
              sx={{
                backgroundColor: "transparent !important",
                border: "1.5px solid rgba(255, 255, 255, 0.6) !important",
                borderColor: "rgba(255, 255, 255, 0.6) !important",
                color: `${colors.neutral.white} !important`,
                "& .MuiButton-startIcon": {
                  color: `${colors.neutral.white} !important`,
                },
                "& .MuiSvgIcon-root": {
                  color: `${colors.neutral.white} !important`,
                },
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.15) !important",
                  borderColor: `${colors.neutral.white} !important`,
                  color: `${colors.neutral.white} !important`,
                },
              }}
            >
              Help Center & FAQs
            </CommonButton>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};

export default AboutCtaCard;
